var render = function render(){var _vm=this,_c=_vm._self._c;return _c('number-field',{attrs:{"outlined":"","dense":"","hide-details":"auto","value":_vm.value,"label":_vm.label,"disabled":_vm.disabled,"limits":_vm.limits,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }